import { createSelector } from 'reselect';
import { errorsToTouch } from '@synergy/utils';

import { AppState } from '../../../../../../store/models/app-state';

const getSupplierDetail = (state: AppState) => state.contactsAndOrganizations.suppliers.supplierDetail;

export const supplierExternalCustomerMappingSelector = createSelector(
    getSupplierDetail,
    state => state.supplierExternalCustomerMappings
);

export const externalCustomerMappingSelector = createSelector(supplierExternalCustomerMappingSelector, state => {
    return {
        formValues: {
            mappings: [...state.externalCustomerMapping],
        },
        errors: { ...state.errors },
        touched: errorsToTouch(state.errors),
    };
});

/** What the tab compares against to decide whether anything is unsaved. */
export const externalCustomerMappingBaselineSelector = createSelector(supplierExternalCustomerMappingSelector, state =>
    state.baseline ? { mappings: [...state.baseline] } : undefined
);
